import {round4} from '../utils'
import type {ArrowWarning} from './geometry'

export function formatWarning(w: ArrowWarning): string {
    switch (w.kind) {
        case 'h-out-of-spec':
            return `h=${w.h} ārpus 100–400 mm`
        case 'below-min-length-705':
            return `Garums ${round4(w.totalLength)} mm < 2.5h (${round4(w.min)} mm)`
        case 'stem-too-short':
            return `stemA=${w.stemA} — ribu garumam jābūt > 0`
    }
}
